import type { IAccount } from '@/types'
import hyRequest from '..'

export function accountLoginRequest(account: IAccount) {
  return hyRequest.post({
    url: 'app-api/system/auth/login-by-account',
    data: account
  })
}
// 短信验证登录
export function smsLoginRequest(account: IAccount) {
  return hyRequest.post({
    url: 'app-api/system/auth/login-by-sms',
    data: account
  })
}
// 拟登录
export function mockLoginTicketRequest(data: { ticket: string }) {
  return hyRequest.post({
    url: 'app-api/system/auth/mock-login-ticket',
    data,
    needAuth: false
  })
}
// 刷新token
export const refreshTokenRequest = (refreshToken: string) => {
  const formData = new FormData()
  formData.append('refreshToken', refreshToken)
  return hyRequest.post({
    url: 'app-api/system/auth/refresh-token',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export function accountLoginOutRequest(accessToken?: string) {
  return hyRequest.post({
    url: 'app-api/system/auth/logout',
    hideLoading: true,
    headers: accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : undefined,
    needAuth: accessToken ? false : undefined
  })
}

export function getUserInfoById(token: string | null) {
  return hyRequest.get({
    url: `app-api/system/user/profile/detail`,
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}
// 获取验证码
export function getCaptcha() {
  return hyRequest.post({
    url: 'app-api/system/captcha/get'
  })
}
export function changePassword(data: {
  newPassword: string
  confirmPassword: string
}) {
  console.log(`output->data`, data)
  return hyRequest.post({
    url: 'app-api/system/user/profile/change-password',
    data
  })
}

export interface RetrieveStudentSchoolInfo {
  platformId: number
  platformName: string
  orgId: number
  orgCode: string
  orgName: string
}

export interface RetrieveStudentSpecialtyInfo {
  specialtyId: number
  specialtyName: string
}

export interface RetrieveStudentInfo {
  studentId: number
  idNumber: string
  studentName: string
  studentSchoolInfos: RetrieveStudentSchoolInfo[]
  studentSpecialtyInfos: RetrieveStudentSpecialtyInfo[]
}

export function getPasswordCaptcha() {
  return hyRequest.get({
    url: 'app-api/system/captcha/image',
    needAuth: false
  })
}

export function sendResetPasswordSmsCode(data: {
  captchaKey: string
  captchaCode: string
  mobile: string
}) {
  return hyRequest.post({
    url: 'app-api/system/auth/send-reset-password-sms-code',
    data,
    needAuth: false
  })
}

export function resetPassword(data: {
  captchaKey: string
  captchaCode: string
  mobile: string
  code: string
  newPassword: string
  confirmPassword: string
}) {
  return hyRequest.post({
    url: 'app-api/system/auth/reset-password',
    data,
    needAuth: false
  })
}

export function getStudentByIdNumber(idNumber: string) {
  return hyRequest.get<{
    code: number
    data: RetrieveStudentInfo
    msg: string
  }>({
    url: 'app-api/reg/student-enrollment/getStudentByIdNumber',
    params: { idNumber },
    needAuth: false
  })
}

export function verifyEnrollStudent(data: {
  platformId: number
  orgId: number
  orgCode: string
  specialtyId: number
  idNumber: string
}) {
  return hyRequest.post({
    url: 'app-api/reg/student-enrollment/verifyEnrollStudent',
    data,
    needAuth: false
  })
}

export function sendForgotPasswordSmsCode(data: {
  captchaKey: string
  captchaCode: string
  mobile: string
  idNumber: string
  accessTerminal?: string
}) {
  return hyRequest.post({
    url: 'app-api/system/auth/send-forgot-password-sms-code',
    data,
    needAuth: false
  })
}

export function validatePasswordNoLogin(data: {
  mobile: string
  newPassword: string
  confirmPassword: string
  smsCode: string
  accessTerminal?: string
}) {
  return hyRequest.post({
    url: 'app-api/system/auth/validatePasswordNoLogin',
    data,
    needAuth: false
  })
}
// 获取关联的平台信息
export function getPlatformInfo(token: string | null) {
  return hyRequest.get({
    url: 'app-api/system/user/platform-info',
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}
// 切换平台信息
export function putPlatformSelection(data: {
  tenantId: string | number
  platformId: string | number
  studentEnrollmentId: string | number
}) {
  return hyRequest.put({
    url: 'app-api/system/user/platform-selection',
    data
  })
}
// 获取机构logo name
export function getCurrentOrgBrand() {
  return hyRequest.get({
    url: '/app-api/reg/student-enrollment/current-org-brand'
  })
}
